import type {GuidedApiQuickLink, GuidedApiSuggestion} from '../api';
import {isEmptyObject} from '../backends/utils';

const groupRoundRobin = function* (items) {
    while (true) {
      for (let i = 0; i < items.length; i++) {
        yield items[i];
      }
    }
};

function extractDoc(splitPerGroup: {}, section, nr) {
    const properSection = splitPerGroup[section];
    if (!properSection)
      return null;
    return properSection[nr];
}

export function withLimiting(
  limits: { [s: string]: number; },
  results:Array<GuidedApiSuggestion|GuidedApiQuickLink>
):Array<GuidedApiSuggestion|GuidedApiQuickLink> {

    if (!limits || isEmptyObject(limits))
      return results;

    const maxTotal = Object.values(limits).reduce((p: number, c: number) => p + c, 0);
    const roundRobin = groupRoundRobin(Object.keys(limits));
    const counts = {};
    const outputSections: {[s:string]:Array<GuidedApiSuggestion|GuidedApiQuickLink>} = {};
    const sectionsDone = {};
    const splitPerGroup = {};

    Object.keys(limits).forEach(key => {
        counts[key] = 0;
        sectionsDone[key] = false;
        outputSections[key] = [];
    });

    results.forEach(i => {
        const group = i.sectionId || 'undefined';
        splitPerGroup[group] = splitPerGroup[group] || [];
        splitPerGroup[group].push(i);
    });

    // filling inital set',`should have ${maxTotal} items`

    if (maxTotal == 0) {
      // limits not configured, returning results without changing
      return results;
    }

    let currentCount = 0;
    while (currentCount < maxTotal) {

      const section = roundRobin.next().value;

      //`Doing iteration count=${currentCount} maxTotal=${maxTotal}`

      const doc = extractDoc(splitPerGroup, section, counts[section]);
      //`trying to fit ${section}`, doc

      if (!doc || counts[section] == limits[section]) {
        sectionsDone[section] = true;
        if (Object.values(sectionsDone).every(r => r)) {
          break;
        }
        continue;
      }

      counts[section]++;
      currentCount++;
      outputSections[section].push(doc);
    }

    // we are done collecting initial collection

    if (currentCount == maxTotal) {
      //collected data, we return the data as unified list
      return Object.values(outputSections).flatMap(v => v);
    }


    // list is not full, so we reset the sectionsDone marker,
    // and try to fill it with other documents
    Object.keys(limits).forEach(key => {
        sectionsDone[key] = false;
    });
    while (currentCount < maxTotal) {
      const section = roundRobin.next().value;
      const doc = extractDoc(splitPerGroup, section, counts[section]);

      if (!doc) {
        sectionsDone[section] = true;
        if (Object.values(sectionsDone).every(r => r)) {
          break;
        }
        continue;
      }

      counts[section]++;
      currentCount++;
      outputSections[section].push(doc);
    }
    return Object.values(outputSections).flatMap(v => v);
}
